import { useCallback, useState, type SyntheticEvent } from 'react';

export type AnchorEl = null | Element | (() => Element);

const usePopoverState = () => {
  const [anchorEl, setAnchorEl] = useState<AnchorEl>(null);

  const open = useCallback(
    (event: SyntheticEvent<AnchorEl, Event> | AnchorEl) => {
      if (!event) setAnchorEl(null);
      else if ('currentTarget' in event) setAnchorEl(event.currentTarget);
      else setAnchorEl(event);
    },
    []
  );
  const close = useCallback(() => setAnchorEl(null), []);

  return {
    anchorEl,
    setAnchorEl,
    isOpen: Boolean(anchorEl),
    open,
    close,
  };
};

export default usePopoverState;
